<template>
  <div>
    <div
      class="rounded-lg relative flex flex-col gap-8"
      :class="[
        !stacked && 'md:flex-row md:items-center',
        variant === 'subtle'
          ? 'bg-static-info-low p-4'
          : 'bg-static-info-mid p-8',
      ]"
    >
      <div :class="['flex flex-row items-center', !stacked && 'md:flex-1']">
        <div
          :class="[
            'ml-16 flex h-40 w-40 shrink-0 items-center',
            !stacked && 'md:h-48 md:w-48',
          ]"
        >
          <RevIllustration
            v-if="isStandardBeforeChristmas || isExpressBeforeChristmas"
            alt=""
            :class="['h-24 w-24', !stacked && 'md:h-32 md:w-32']"
            :height="32"
            src="/img/product/delivery-before-christmas.svg"
            :width="32"
          />
          <IconTruckExpress
            v-else
            :class="['h-24 w-24', !stacked && 'md:h-32 md:w-32']"
          />
        </div>
        <div class="flex min-w-0 flex-1 flex-col text-left">
          <div class="body-2-bold">
            <slot name="title">
              <span
                v-if="isStandardBeforeChristmas && free"
                data-allow-mismatch="text"
              >
                {{
                  i18n(translations.freeShippingBeforeChristmas, {
                    earliest: free.earliest,
                    latest: free.latest,
                  })
                }}
              </span>

              <FormattedMessage
                v-else-if="free"
                :definition="translations.freeShipping"
              >
                <template #dates>
                  <span data-allow-mismatch="text">
                    {{
                      i18n(translations.freeShippingDates, {
                        earliest: free.earliest,
                        latest: free.latest,
                      })
                    }}
                  </span>
                </template>
              </FormattedMessage>

              <span v-else>
                {{ i18n(translations.freeShippingWithoutDates) }}
              </span>
            </slot>
          </div>
          <div v-if="express" class="caption">
            <span
              :class="{
                'text-static-success-hi':
                  isExpressBeforeChristmas && !isStandardBeforeChristmas,
              }"
              data-allow-mismatch="text"
            >
              <template v-if="isExpressBeforeChristmas">
                {{
                  i18n(translations.expressShippingBeforeChristmas, {
                    amount: express.amount,
                    earliest: express.earliest,
                    latest: express.latest,
                  })
                }}
              </template>
              <template v-else>
                {{
                  i18n(translations.expressShipping, {
                    amount: express.amount,
                    earliest: express.earliest,
                    latest: express.latest,
                  })
                }}
              </template>
            </span>
          </div>
        </div>
      </div>
      <div
        v-if="$slots['extra-info']"
        aria-hidden="true"
        class="h-1 bg-float-default-low"
        :class="[
          !stacked && 'md:hidden',
          variant === 'subtle' ? '-mx-4' : '-mx-8',
        ]"
      ></div>
      <div
        v-if="$slots['extra-info']"
        :class="['ml-16 shrink-0', !stacked && 'md:mb-0 md:ml-0 md:mr-16']"
      >
        <slot name="extra-info" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import FormattedMessage from '@backmarket/nuxt-module-i18n/FormattedMessage.vue'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevIllustration } from '@ds/components/Illustration'
import { IconTruckExpress } from '@ds/icons/IconTruckExpress'

import translations from '../DeliveryPromise/DeliveryPromise.translations'

defineProps<{
  free: { earliest: string; latest: string } | null
  express: { earliest: string; latest: string; amount: string } | null
  isStandardBeforeChristmas: boolean
  isExpressBeforeChristmas: boolean
  variant?: 'default' | 'subtle'
  stacked?: boolean
}>()

const i18n = useI18n()
</script>
